import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { pellaConfig } from "./data";

export default function PellaPage() {
  return <CityPageTemplate config={pellaConfig} />;
}